import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, useFetch, useForm, useModal, useResource, useToast, usePage } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_REGN_CD_INFO } from "@/tra/tancis/ptli/comnmdle/regncd/services/PtliRegnCdService";

/*
 * Region Code Registration
 * !== 지역 코드 등록 ==!
 */
export const PTLI0415002S = () => {
    useResource({
        defaultSchema: [
            { area: "cntyCd" },
            { area: "comnCd", comnCd: "COM0033" },
            { area: "comnCd", comnCd: "COM0064" }, // 활성화 여부 코드
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        regnCdInfo: useForm({
            defaultSchema: SF_REGN_CD_INFO,
        }),
    };

    const fetch = {
        insertRegnCdInfo: useFetch({
            api: (data: any) => APIS.insertRegnCdInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0415001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.regnCdInfo.reset();
        },
        onListBtnClick: () => {
            navigate(URLS.ptli0415001q);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.regnCdInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.regnCdInfo.handleSubmit(
                () => {
                    const data = form.regnCdInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.insertRegnCdInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.regnCdInfo.errors), form.regnCdInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.regnCdInfo.clearErrors();
            form.regnCdInfo.resetSchema();
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnCd} />
                            <Group.Control {...form.regnCdInfo.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.cntyCd} />
                            <Group.Control {...form.regnCdInfo.schema.cstmOfceCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmEn} />
                            <Group.Control {...form.regnCdInfo.schema.regnNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdInfo.schema.regnNmTz} />
                            <Group.Control {...form.regnCdInfo.schema.portYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
